import { i18n_t as $t } from '@utils/i18n';

export const getCatalogCategories = () => {
    return {
        ACCOUNTS: $t('Accounts'),
        AI_AGENTS: $t('AI Agents'),
        FEATURES: $t('Features'),
        FEEDBACK: $t('Feedback'),
        GENERAL: $t('General'),
        GUIDES: $t('Guides'),
        MOBILE: $t('Mobile'),
        PAGES: $t('Pages'),
        REPLAY: $t('Replay'),
        REPORTS: $t('Reports'),
        SYSTEM: $t('System'),
        TRACK_EVENTS: $t('Track Events'),
        VISITORS: $t('Visitors'),
    };
};
